import { MessageStatus } from '@dadohr/shared/domainTypes/experience';
import assertNever from 'assert-never';
import { useMemo } from 'react';
import { Color, ColoredChip } from '../../../../components/ColoredChip';
import { UnsafeTFunction, useUnsafeTranslation } from '../../../../i18next';

export const getMessageStatusChipConfig = (
  status: MessageStatus,
  t: UnsafeTFunction
): [string, Color] => {
  switch (status) {
    case MessageStatus.UPCOMING:
      return [t('Upcoming'), 'gray'];
    case MessageStatus.TRIGGERED:
      return [t('Triggered'), 'gray'];
    case MessageStatus.DONE:
      return [t('Done'), 'green'];
    case MessageStatus.ERROR:
      return [t('Error'), 'red'];
    case MessageStatus.SKIPPED:
      return [t('Skipped'), 'darkGray'];
    default:
      return assertNever(status);
  }
};

export const MessageStatusChip: React.FC<{
  status: MessageStatus;
  variant?: 'rounded' | 'squared';
  autoWidth?: boolean;
  color?: 'light' | 'normal';
}> = ({ status, variant, autoWidth, color = 'normal' }) => {
  const { t } = useUnsafeTranslation();
  const [label, c] = useMemo(() => getMessageStatusChipConfig(status, t), [status, t]);
  return (
    <ColoredChip
      color={c}
      size="small"
      width={autoWidth ? 'auto' : 104}
      variant={variant}
      mode={color}
    >
      {label}
    </ColoredChip>
  );
};
